import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {getBonusTasks, submitBonusTask} from 'game/app/actions/bonus-tasks-actions';
import BonusTaskForm from "../common/bonus-task-form";
import {Link, Route, Switch} from "react-router-dom";
import GameComponent from "game/app/components/game/game-component";
import Oblast1 from "./tasks/oblast_1";
import Oblast2 from "./tasks/oblast_2";
import Oblast3 from "./tasks/oblast_3";
import Oblast4 from "./tasks/oblast_4";
import Oblast5 from "./tasks/oblast_5";
import Oblast6 from "./tasks/oblast_6";
import assets from "game/app/assets";
import {setTheme} from "game/app/actions/theme-actions";


class Tasks extends GameComponent {

    componentWillMount() {
        this.props.getBonusTasks(this.props.match.params.instance_id);
    }

    submitBonusTask(task) {
        return (values, form) => {
            this.props.submitBonusTask(this.getInstanceId(), task.id, values).then(() => {
                form.resetForm();
                form.setSubmitting(false);
            });
        }
    }

    showTask(id) {
        return this.props.bonusTasks.list.filter((task) => task.id === id ).map((task) => <BonusTaskForm key={task.id} resource={task} handleSubmit={this.submitBonusTask(task)}/>)
    }

    render() {
        let instanceId = this.props.match.params.instance_id;

        return (
            <div className='container'>
                <Switch>
                    <Route path='/game/:instance_id/ukoly/1' component={Oblast1}/>
                    <Route path='/game/:instance_id/ukoly/2' component={Oblast2}/>
                    <Route path='/game/:instance_id/ukoly/3' component={Oblast3}/>
                    <Route path='/game/:instance_id/ukoly/4' component={Oblast4}/>
                    <Route path='/game/:instance_id/ukoly/5' component={Oblast5}/>
                    <Route path='/game/:instance_id/ukoly/6' component={Oblast6}/>
                    <Route render={() => {
                        return (
                            <div className={this.mainContainerClass}>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['zs_2019']['zs_2019_fin_gram']} className='img-fluid'/>
                                                <h5>FINANČNĚ GRAMOTNÝ ČLOVĚK</h5>
                                                <Link to={`/game/${this.getInstanceId()}/ukoly/1`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['zs_2019']['zs_2019_vydaje']} className='img-fluid'/>
                                                <h5>ZÁKLADNÍ VÝDAJE V ROZPOČTU</h5>
                                                <Link to={`/game/${this.getInstanceId()}/ukoly/2`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['zs_2019']['zs_2019_internet']} className='img-fluid'/>
                                                <h5>INTERNET A OBRÁZKY</h5>
                                                <Link to={`/game/${this.getInstanceId()}/ukoly/3`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['zs_2019']['zs_2019_psane_slovo']} className='img-fluid'/>
                                                <h5>PSANÉ SLOVO</h5>
                                                <Link to={`/game/${this.getInstanceId()}/ukoly/4`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['zs_2019']['zs_2019_video']} className='img-fluid'/>
                                                <h5>VIDEO, PREZENTACE</h5>
                                                <Link to={`/game/${this.getInstanceId()}/ukoly/5`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className='card'>
                                            <div className='card-body text-center'>
                                                <img src={assets['zs_2019']['zs_2019_hry']} className='img-fluid'/>
                                                <h5>HRY A APLIKACE</h5>
                                                <Link to={`/game/${this.getInstanceId()}/ukoly/6`} className='btn btn-primary'>Vstoupit</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }}/>
                </Switch>
            </div>
        );
    }
}


function mapStateToProps(state,ownProps) {
    return {
        bonusTasks: state.bonusTasks,
        gameInstance: state.gameInstance,
        theme: state.theme
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        getBonusTasks: getBonusTasks,
        submitBonusTask: submitBonusTask,
        setTheme: setTheme
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Tasks);
